import React from "react";
import PopUp, { closePopUp } from "../../../components/popUp";
import UploadLoader from "../../../components/uploadLoader";
import Button from "../../../components/button";
import { useNavigate } from "react-router-dom";
import { useSafeNavigate } from "../../../components/unloadBlocker";

interface PieceUploadingPopUpProps {
    msg?: string;
    success?: boolean;
    width?: number;
    height?: number;
}

export default function PieceUploadingPopUp(props: PieceUploadingPopUpProps) {

    const navigate = useSafeNavigate(useNavigate());

    return <PopUp height={props.height} width={props.width} className="big center">
        <UploadLoader success={props.success}/>
        {props.success == undefined ? <></> : props.success ? <>
        
            <h1>Upload successfull!!</h1>
            <h3>Thank you.</h3>
            <p style={{
                marginTop: "auto"
            }}>{props.msg}</p>
            <Button onClick={() => {
                closePopUp();
                navigate("/dashboard/mypieces");
            }}>Hurray</Button>
        </> : <>
            <h1>An error occurred</h1>
            <p style={{
                marginTop: "auto"
            }}>{props.msg}</p>
            <Button onClick={() => {
                closePopUp();
                navigate("/dashboard/mypieces");
            }}>Close</Button>
        </>}
    </PopUp>
}